import { useState } from "react";
import { ChevronDown, ChevronRight, TrendingUp } from "lucide-react";

const MainEnginePower = () => {
  const [openSections, setOpenSections] = useState(false);

  const toggleSection = () => {
    setOpenSections((prev) => !prev);
  };

  const powerMetrics = [
    {
      id: "power",
      title: "Main Engine Power",
      description: "Energy consumption measurement in kilowatts (KW)",
      field: "ME Power (KW)",
      calculation: "Parsed from pipe-separated string values",
      processing: 'String(row["ME Power (KW)"] || "0").split("|").map(v => parseFloat(v) || 0)',
      output: "Kilowatts (KW)",
      borderColor: "border-blue-200",
      bgColor: "bg-blue-50",
      textColor: "text-blue-700",
    },
    {
      id: "rpm",
      title: "Main Engine RPM",
      description: "Average Revolutions Per Minute of main engine",
      field: "ME RPM",
      calculation: "Parsed from pipe-separated string values",
      processing: 'String(row["ME RPM"] || "0").split("|").map(v => parseFloat(v) || 0)',
      output: "Revolutions Per Minute (RPM)",
      borderColor: "border-green-200",
      bgColor: "bg-green-50",
      textColor: "text-green-700",
    },
  ];

  return (
    <div>
      <div className="mb-6 border border-gray-300 rounded-lg overflow-hidden">
        <button
          className="flex items-center justify-between w-full p-5 bg-gray-50 hover:bg-gray-100 transition-colors"
          onClick={toggleSection}
        >
          <div className="flex items-center gap-4">
            <div className="p-3 bg-[#d5e7f7] rounded-lg">
              <TrendingUp className="w-6 h-6 text-[#566573]" />
            </div>
            <div className="text-left">
              <h2 className="text-md font-bold text-gray-800">
                Main Engine Power & RPM Data
              </h2>
              <p className="text-gray-600 text-sm">
                Power consumption and engine RPM measurements with pipe-separated data parsing
              </p>
            </div>
          </div>
          {openSections ? (
            <ChevronDown className="w-5 h-5 text-gray-500" />
          ) : (
            <ChevronRight className="w-5 h-5 text-gray-500" />
          )}
        </button>

        {openSections && (
          <div className="p-5 bg-white border-t border-gray-200">
            {/* Power Metrics */}
            <div className="mb-6">
              <h4 className="font-semibold text-gray-800 mb-3">Source Data Fields & Processing</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                {powerMetrics.map((metric) => (
                  <div
                    key={metric.id}
                    className={`p-5 rounded-lg border ${metric.borderColor} ${metric.bgColor}`}
                  >
                    <div className="flex items-center gap-3 mb-3">
                      <div className="flex-1">
                        <div className="flex justify-between items-start">
                          <div>
                            <h4 className="font-semibold text-gray-800">
                              {metric.title}
                            </h4>
                            <p className="text-xs text-gray-500">Source Field: {metric.field}</p>
                          </div>
                          <span className={`text-xs font-medium px-2 py-1 rounded ${metric.textColor} ${metric.bgColor.replace('50', '100')}`}>
                            Pipe-separated
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="mb-3">
                      <p className="text-sm font-medium text-gray-700 mb-1">Description:</p>
                      <p className="text-sm text-gray-600">{metric.description}</p>
                    </div>

                    <div className="mb-3">
                      <p className="text-sm font-medium text-gray-700 mb-1">Processing Code:</p>
                      <div className="text-xs text-gray-700 bg-white p-2 rounded border font-mono overflow-x-auto">
                        {metric.processing}
                      </div>
                    </div>

                    <div className="mb-3">
                      <p className="text-sm font-medium text-gray-700 mb-1">Data Flow:</p>
                      <div className="text-sm text-gray-600 space-y-1">
                        <div className="flex items-center gap-2">
                          <div className="w-2 h-2 bg-gray-400 rounded-full"></div>
                          <span>CSV/Excel: <code className="text-xs bg-gray-100 px-1 rounded">{metric.field}</code></span>
                        </div>
                        <div className="flex items-center gap-2">
                          <div className="w-2 h-2 bg-gray-400 rounded-full"></div>
                          <span>Parsing: Split by "|" → Parse floats</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <div className="w-2 h-2 bg-gray-400 rounded-full"></div>
                          <span>Storage: <code className="text-xs bg-gray-100 px-1 rounded">{metric.id === "power" ? "mekwhCounter" : "averageRPM"}</code></span>
                        </div>
                      </div>
                    </div>

                    <div>
                      <p className="text-sm font-medium text-gray-700 mb-1">Output Unit:</p>
                      <p className={`text-sm font-semibold ${metric.textColor}`}>
                        {metric.output}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MainEnginePower;